var map = {
	"./antiseptics/dettol-liquid.jpg": "336e",
	"./antiseptics/dettol-spray.jpg": "3e9b",
	"./antiseptics/hexisol.jpg": "3018",
	"./antiseptics/savlon-liquid.jpg": "c1d0",
	"./antiseptics/savlon-spray.jpg": "343e",
	"./colorsFlavors/apple-cider.jpg": "3388",
	"./colorsFlavors/kasundi.jpg": "50f7",
	"./colorsFlavors/soya-sauce.jpg": "b850",
	"./colorsFlavors/white-vinegar.jpg": "de98",
	"./colorsFlavors/yellow-mustard.jpg": "a511",
	"./fruits/green-coconut.jpg": "8a4e",
	"./fruits/guava.jpg": "ee34",
	"./fruits/papaya.jpg": "69d7",
	"./fruits/pineapple.jpg": "6ba7",
	"./fruits/pomegranate.jpg": "4ce7",
	"./softDrinks/coke.jpg": "f7d8",
	"./softDrinks/fanta.jpg": "9c20",
	"./softDrinks/frutika.jpg": "94af",
	"./softDrinks/pepsi.jpg": "5d8e",
	"./softDrinks/sprite.jpg": "1c45",
	"./spices/black-cumin.jpg": "e932",
	"./spices/cinamon.jpg": "382e",
	"./spices/cumin-seeds.jpg": "e4c5",
	"./spices/dried-chillies.jpg": "e2a9",
	"./spices/fennel-seeds.jpg": "1cc6",
	"./supplements/boost.jpg": "5dd7",
	"./supplements/ensure-diabetes.jpg": "52db",
	"./supplements/ensure-vanilla.jpg": "ee9b",
	"./supplements/horlicks.jpg": "da77",
	"./supplements/pediasure-vanilla.jpg": "6baa",
	"./syrupsPowders/hershey-choco.jpg": "3360",
	"./syrupsPowders/ovaltine.jpg": "8210",
	"./syrupsPowders/pancake-syrup.jpg": "242a",
	"./syrupsPowders/tang-orange.jpg": "a409",
	"./syrupsPowders/tang-pineapple.jpg": "76c1",
	"./vegetables/carrot.jpg": "72f1",
	"./vegetables/gourd.jpg": "2c2a",
	"./vegetables/potato.jpg": "c110",
	"./vegetables/potol.jpg": "5b8f",
	"./vegetables/spinach.jpg": "6981"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "99c9";